/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gd_Page_TitleInputs */

const en_gd_page_title = /** @type {(inputs: Gd_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ask for a review`)
};

const id_gd_page_title = /** @type {(inputs: Gd_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minta ditinjau`)
};

/**
* | output |
* | --- |
* | "Ask for a review" |
*
* @param {Gd_Page_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const gd_page_title = /** @type {((inputs?: Gd_Page_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gd_Page_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_gd_page_title(inputs)
	return en_gd_page_title(inputs)
});